import { z } from 'zod';
import { BibleLocationSchema } from '../bible/bible-location.js';
/**
 * Note schema - a note attached to a verse
 */
export const NoteSchema = BibleLocationSchema.extend({
    noteText: z.string(),
});
//# sourceMappingURL=note.js.map